import "./bandeauRedirectionView.scss";

import { DOMHelper, Point, View } from "~ui-lib";

export class HeaderHomeView extends View {
  private _bandeauRedirectionView: BandeauRedirectionView;
  private _logoElement: HTMLImageElement;
  constructor() {
    super(DOMHelper.createDivWithParent(null, "", "header"));
    this._bandeauRedirectionView = new BandeauRedirectionView("homeVariant");
    this.rootElement.appendChild(this._bandeauRedirectionView.rootElement);
    this._logoElement = DOMHelper.createImg(
      this.rootElement,
      null,
      "logo",
      require("~images/pictos_okoo/logo_okoo.png"),
      ""
    );
  }
  onFocused = () => {
    this._bandeauRedirectionView.rootElement.classList.add("focused");
  };
  onUnfocused = () => {
    this._bandeauRedirectionView.rootElement.classList.remove("focused");
  };

  onMouseDown = (_: Point, targetElement: HTMLElement) => {
    // if user click on logo or rootElement (meaning user don't click on the "bandeau"), we return true to ignore the click
    if (targetElement === this._logoElement || targetElement === this.rootElement) {
      return true;
    }
    return false;
  };
}

const _map = {
  homeVariant: {
    descriptionInnerHtml:
      'Une seule app TV pour tout le monde :<br> Okoo s’installe définitivement <span class="boldText">sur france.tv !</span>',
    buttonText: "Regarder Okoo sur france.tv",
  },
  agePageVariant: {
    descriptionInnerHtml:
      'Pour les petits et les grands : <br> <span class="boltText">découvre encore plus de programmes adaptés à chaque âge sur france.tv !</span>',
    buttonText: "Aller sur france.tv",
  },
};

export class BandeauRedirectionView extends View {
  constructor(variant: "homeVariant" | "agePageVariant", isthisFirstPage?: boolean) {
    super(
      DOMHelper.createDivWithParent(
        null,
        "",
        "bandeauRedirectionFocusBox" + " " + variant + (isthisFirstPage ? " nomenu" : "")
      )
    );

    const bandeauRedirectionBox = DOMHelper.createDivWithParent(this.rootElement, "", "bandeauRedirectionBox");

    const imgContainer = DOMHelper.createDivWithParent(bandeauRedirectionBox, "", "leftRectangle");
    DOMHelper.createImg(imgContainer, null, "imgOkooFrancetv", require("~images/banner/okoo_to_francetv.png"), "");

    const bandeauText = DOMHelper.createDivWithParent(bandeauRedirectionBox, null, "bandeauText", "");
    bandeauText.innerHTML = _map[variant].descriptionInnerHtml;

    const redirectionButton = DOMHelper.createDivWithParent(bandeauRedirectionBox, null, "redirectionButton");
    DOMHelper.createDivWithParent(redirectionButton, null, "redirectionText", _map[variant].buttonText);
    DOMHelper.createImg(redirectionButton, null, "redirectionIcon", require("~images/decommissionnement/goTo.png"), "");
  }
}
